import React from "react";

import { splitTextOnCloze } from "../../helpers";

import AiSuggestedChanges from "./AiSuggestedChanges";
import Checkbox from "../Checkbox";
import ClozeSentenceEntry from "../mods/ClozeSentenceEntry";
import CollectionClozeSentenceChangesModal from "../mods/CollectionClozeSentenceChangesModal";
import CollectionClozeSentenceEditor from "../mods/CollectionClozeSentenceEditor";
import CollectionClozeSentenceExplanation from "../CollectionClozeSentenceExplanation";
import CollectionClozeSentenceTts from "../mods/CollectionClozeSentenceTts";
import Icon from "../Icon";
import Loading from "../Loading";
import Modal from "../Modal";
import ModalFooterCloseBtn from "../ModalFooterCloseBtn";
import Pagination from "../Pagination";
import ProgressBar from "../ProgressBar";
import TokensEditor from "../mods/TokensEditor";

// Guarded because Safari throws outright on localStorage in private browsing, and a
// remembered checkbox is not worth taking the page down for.
function readStoredFlag(key) {
  try {
    return localStorage.getItem(key) === "true";
  }
  catch(e) {
    return false;
  }
}

function writeStoredFlag(key, value) {
  try {
    localStorage.setItem(key, value ? "true" : "false");
  }
  catch(e) {
    // Preference just won't stick.
  }
}

const FIELD_NAMES = { text: "sentence", translation: "translation" };

// A hand edit to the wording leaves the AI's diff about text that no longer exists - the
// apply endpoint would refuse it. The server marks it stale on the next load; this does
// the same without one.
export function withAiRecommendationStaleness(before, after) {
  const { aiRecommendation } = after;
  const reworded = before.text !== after.text || before.translation !== after.translation;
  if(!aiRecommendation || aiRecommendation.appliedAt || !reworded) {
    return after;
  }

  return Object.assign({}, after, {
    aiRecommendation: Object.assign({}, aiRecommendation, { proposedChanges: {}, stale: true })
  });
}

export default class ReportedCollectionClozeSentences extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      aiVerdict: "",
      applyModalVisible: false,
      collections: null,
      // Recommendations stay closed until asked for. The sentence, the reports and your own read
      // of them come first - a verdict read before you've looked is a verdict you'll agree
      // with. Flip expandAiRecommendations if you'd rather have them all open; the choice
      // sticks, since re-checking a box on every page of thirty out of thirty thousand is
      // its own reason to stop using the queue.
      expandAiRecommendations: readStoredFlag("expandAiRecommendations"),
      expandedAiRecommendations: {},
      includeResolved: true,
      includeSeen: true,
      languagePairings: null,
      loading: true,
      notifyUsersOnResolve: true,
      orderBy: null,
      page: 1,
      perPage: 50,
      recommending: {},
      reportedSentence: null,
      reportedSentences: [],
      resolveModalVisible: false,
      selectedCollectionId: parseInt(props.selectedCollectionId) || "",
      selectedLanguagePairingId: parseInt(props.selectedLanguagePairingId) || "",
      showVerdictReasonFor: {},
      total: 0
    };
  }

  componentDidMount() {
    this.loadErrors();
  }

  loadErrors() {
    this.setState({ loading: true });

    const data = {
      ai_verdict: this.state.aiVerdict,
      include_resolved: this.state.includeResolved,
      include_marked_as_seen: this.state.includeSeen,
      order_by: this.state.orderBy,
      page: this.state.page
    };

    if(this.props.languagePairingsSelector) {
      data.collection_id = this.state.selectedCollectionId;
      data.language_pairing_id = this.state.selectedLanguagePairingId;
      data.include_language_pairings = true;
    }

    $.ajax({
      data,
      url: this.props.url
    })
      .done((data) => {
        console.log(data);
        const state = {
          loading: false,
          reportedSentences: data.reportedCollectionClozeSentences,
          total: data.total
        };

        if(this.props.languagePairingsSelector) {
          state.collections = data.collections;
          state.languagePairings = data.languagePairings;
          state.allLanguagePairingsResolvedCount = data.languagePairings.reduce((s, lp) => s + lp.resolved, 0)
          state.allLanguagePairingsTotalCount = data.languagePairings.reduce((s, lp) => s + lp.total, 0);
        }

        this.setState(state);
      })
      .fail(() => {
        alert(
          "Oh no! There was an error loading errors. Sorry about that. " +
          "Please try again and let us know if you see this message again."
        );
      });
  }

  onEditSentenceClick(e) {
    this.setState({ editingReportedSentence: e });
  }

  // onViewSentenceClick(e) {
  //   this.setState({ updating: true });
  //   $.ajax({
  //     url: e.collectionClozeSentenceUrl
  //   })
  //     .done((data) => {
  //       this.setState({
  //         collectionClozeSentence: data.collectionClozeSentence,
  //         updating: false
  //       });
  //     })
  //     .fail(() => {
  //       this.setState({ updating: false });
  //       alert("Oh no! There was an error loading the sentence. Sorry about that. Please try again and let us know if you see this message again.");
  //     });
  // }

  onClaimClick(reportedSentence) {
    this.updateClaim({ url: reportedSentence.claimUrl });
  }

  onRemoveClaimClick(reportedSentence) {
    this.updateClaim({ url: reportedSentence.removeClaimUrl });
  }

  updateClaim({ url }) {
    this.setState({ updating: true });
    $.ajax({
      method: "post",
      url
    })
      .done((data) => {
        console.log(data);
        const { reportedCollectionClozeSentence } = data;
        this.setState({
          reportedSentences: this.state.reportedSentences.map((e) => (
            e.id === reportedCollectionClozeSentence.id ? Object.assign({}, e, reportedCollectionClozeSentence) : e
          )),
          updating: false
        });
      })
      .fail(() => {
        this.setState({ updating: false });
        alert("Oh no! There was an error claiming the sentence! Sorry about that. Please try again let us know if you see this message again.");
      });
  }

  onMarkAsSeenClick(e) {
    this.setState({ updating: true });
    $.ajax({
      method: "post",
      url: e.markAsSeenUrl
    })
      .done((data) => {
        console.log(data);
        const { reportedCollectionClozeSentence } = data;
        this.setState({
          reportedSentences: this.state.reportedSentences.map((e) => (
            e.id === reportedCollectionClozeSentence.id ? Object.assign({}, e, reportedCollectionClozeSentence) : e
          )),
          updating: false
        });
      })
      .fail(() => {
        this.setState({ updating: false });
        alert("Oh no! There was an error marking the sentence as seen! Sorry about that. Please try again let us know if you see this message again.");
      });
  }

  onResolveClick(reportedSentence) {
    this.setState({ reportedSentence, resolveModalVisible: true });
  }

  resolve({ reportedSentence, notifyUsers = false }) {
    this.setState({ updating: true });
    $.ajax({
      contentType: "application/json",
      data: JSON.stringify({ notify_users: notifyUsers }),
      method: "put",
      url: reportedSentence.resolveUrl
    })
      .done((data) => {
        console.log(data);
        const { reportedCollectionClozeSentence } = data;

        this.onResolved(reportedSentence, reportedCollectionClozeSentence);
      })
      .fail(() => {
        this.setState({ updating: false });
        alert("Oh no! There was an error resolving the sentence! Sorry about that. Please try again let us know if you see this message again.");
      });
  }

  onResolved(reportedSentence, attributes) {
    const state = {
      reportedSentences: this.state.reportedSentences.map((e) => (
        e.id === attributes.id ? Object.assign({}, e, attributes) : e
      )),
      updating: false
    };

    if(this.props.languagePairingsSelector) {
      state.languagePairings = this.state.languagePairings.map((lp) => (
        reportedSentence.languagePairingId === lp.id ? Object.assign({}, lp, { resolved: lp.resolved + 1 }) : lp
      ));
    }

    state.allLanguagePairingsResolvedCount = this.state.allLanguagePairingsResolvedCount + 1;

    this.setState(state);
  }

  onApplyAiRecommendationClick(reportedSentence) {
    this.setState({ applyModalVisible: true, reportedSentence });
  }

  // Claim, edit, resolve and (optionally) notify in one request. Sends back exactly the
  // changes it was shown - the server checks them against the stored proposal and refuses
  // if the sentence or the recommendation has moved on since this page loaded.
  applyAiRecommendation({ notifyUsers = false, reportedSentence }) {
    const { aiRecommendation } = reportedSentence;
    const changes = aiRecommendation.proposedChanges || {};

    this.setState({ updating: true });
    $.ajax({
      contentType: "application/json",
      data: JSON.stringify({
        ai_recommendation_id: aiRecommendation.id,
        notify_users: notifyUsers,
        text: changes.text || null,
        translation: changes.translation || null
      }),
      method: "put",
      url: reportedSentence.applyAiRecommendationUrl
    })
      .done((data) => {
        this.onResolved(reportedSentence, data.reportedCollectionClozeSentence);
        if(data.parentClozeSentenceError) {
          alert("Applied, but the parent cloze sentence couldn't be updated: " + data.parentClozeSentenceError);
        }
      })
      .fail((jqXHR) => {
        this.setState({ updating: false });
        alert("Couldn't apply the changes: " + ((jqXHR.responseJSON || {}).errors || "unknown error"));
      });
  }

  renderApplyModal() {
    const { applyModalVisible, notifyUsersOnResolve, reportedSentence } = this.state;
    if(!applyModalVisible || !reportedSentence) {
      return null;
    }

    const { aiRecommendation } = reportedSentence;

    return (
      <Modal
        footer={<ModalFooterCloseBtn text="Cancel" />}
        onHidden={() => this.setState({ applyModalVisible: false, reportedSentence: null })}
        ref={(el) => this.applyModal = el}
        size="small"
        title="Apply AI Changes"
      >
        <AiSuggestedChanges
          changes={aiRecommendation.proposedChanges}
          current={{ text: reportedSentence.text, translation: reportedSentence.translation }}
          languageIsos={{ text: reportedSentence.targetLanguageIso, translation: reportedSentence.baseLanguageIso }}
        />
        <p className="alert alert-danger" style={{ marginTop: 10 }}>
          This saves the changes above and resolves the sentence
          {reportedSentence.claimedByCurrentUser ? "" : ", claiming it for you"}.
          {" "}It will no longer be editable from here. This action cannot be undone.
        </p>
        <Checkbox
          checked={notifyUsersOnResolve}
          label="Notify users"
          onChange={(e) => this.setState({ notifyUsersOnResolve: e.target.checked })}
        />
        <button
          className="btn btn-success joystix btn-block"
          onClick={() => this.applyModal.hide({
            onHidden: () => this.applyAiRecommendation({ notifyUsers: this.state.notifyUsersOnResolve, reportedSentence })
          })}
        >
          Apply &amp; Resolve
        </button>
      </Modal>
    );
  }

  renderResolveModal() {
    const { notifyUsersOnResolve, reportedSentence, resolveModalVisible } = this.state;
    if(!resolveModalVisible) {
      return null;
    }

    return (
      <Modal
        footer={<ModalFooterCloseBtn text="Cancel" />}
        onHidden={() => this.setState({ reportedSentence: null, resolveModalVisible: false })}
        ref={(el) => this.resolveModal = el}
        size="small"
        title="Resolve Sentence"
      >
        <p className="alert alert-danger">
          Are you sure? The sentence will no longer be editable and the users who reported the sentence will be notified. This action cannot be undone.
        </p>
        <Checkbox
          checked={notifyUsersOnResolve}
          label="Notify users"
          onChange={(e) => this.setState({ notifyUsersOnResolve: e.target.checked })}
        />
        <button
          className="btn btn-success joystix btn-block"
          onClick={() => this.resolveModal.hide({ onHidden: () => this.resolve({ notifyUsers: this.state.notifyUsersOnResolve, reportedSentence }) })}
        >
          Resolve
        </button>
      </Modal>
    );
  }

  renderCollectionClozeSentenceExplanationModal() {
    const { explanationModalVisible, reportedSentence } = this.state;
    if(!explanationModalVisible) {
      return null;
    }

    return (
      <Modal
        footer={<ModalFooterCloseBtn text="Cancel" />}
        onHidden={() => this.setState({ explanationModalVisible: false, reportedSentence: null })}
        ref={(el) => this.explanationModal = el}
        title="Explanation"
      >
        <div className="well">
          <p><small>Explanations are from ChatGPT. Sometimes they come back from ChatGPT as Markdown. Until we get a Markdown editor implemented, the only option for now is to delete the explanation so it regenerates the next time a user clicks/taps the Explain button after answering.</small></p>
          <p>
            <button className="btn btn-danger" onClick={() => confirm("Are you sure?") && this.unsetExplanation(reportedSentence)}>Delete Explanation</button>
          </p>
          <small>Click "Explanation" again after deleting to regenerate the explanation, otherwise it will be regenerated the next time a user clicks "Explanation" while playing.</small>
        </div>
        <CollectionClozeSentenceExplanation
          collectionClozeSentence={{ id: reportedSentence.collectionClozeSentenceId, explanationJobUrl: reportedSentence.explanationJobUrl }}
          key={reportedSentence.collectionClozeSentenceId}
          onExplanation={(explanation) => {
            const updatedSentence = Object.assign({}, reportedSentence, { explanation });
            this.setState({
              reportedSentences: this.state.reportedSentences.map((r) => r.id === reportedSentence.id ? updatedSentence : r)
            });
          }}
          // test={this.props.test}
        />
      </Modal>
    );
  }

  unsetExplanation(reportedSentence) {
    const { collectionClozeSentenceUnsetExplanationUrl } = reportedSentence;
    $.ajax({
      method: "put",
      url: collectionClozeSentenceUnsetExplanationUrl
    })
      .done(({ collectionClozeSentence }) => {
        const updatedSentence = Object.assign({}, reportedSentence, { explanation: collectionClozeSentence.explanation });
        this.setState({
          reportedSentences: this.state.reportedSentences.map((r) => r.id === reportedSentence.id ? updatedSentence : r)
        });
      })
      .fail(() => {
        alert("Error!");
      });
    this.explanationModal && this.explanationModal.hide();
  }

  renderPagination() {
    const { page, perPage, total, updating } = this.state;
    return (
      <Pagination
        onNextClick={() => this.setState({ page: this.state.page + 1 }, () => this.loadErrors())}
        onPrevClick={() => this.setState({ page: this.state.page - 1 }, () => this.loadErrors())}
        page={page}
        perPage={perPage}
        total={total}
        updating={updating}
      />
    );
  }

  // renderViewCollectionClozeSentenceModal() {
  //   const { collectionClozeSentence, updateUrl } = this.state;
  //   if(collectionClozeSentence && !updateUrl) {
  //     const { preClozeStr, cloze, postClozeStr } = splitTextOnCloze(collectionClozeSentence.text);
  //     return (
  //       <Modal
  //         footer={<ModalFooterCloseBtn />}
  //         onHidden={() => this.setState({ collectionClozeSentence: null })}
  //         size="small"
  //         title="View Sentence"
  //       >
  //         {["text", "translation", "pronunciation", "notes", "hint", "alternativeAnswers"].map((attr) => (
  //           <p key={attr}>
  //             <strong>
  //               {
  //                 attr.split(/([A-Z])/).map((x, i, a) => (
  //                   i === 0 ? x.charAt(0).toUpperCase() + x.slice(1) : (i % 2 === 1 ? " " : (a[i - 1].toLowerCase() + x))
  //                 )).join("")
  //               }:
  //             </strong>
  //             <br />
  //             {attr === "text" ? <span>{preClozeStr}<strong><u>{cloze}</u></strong>{postClozeStr}</span> : collectionClozeSentence[attr]}
  //           </p>
  //         ))}
  //         {!!collectionClozeSentence.ttsAudioUrl && <audio controls src={collectionClozeSentence.ttsAudioUrl} style={{ maxWidth: "100%" }}></audio>}
  //       </Modal>
  //     );
  //   }
  // }

  onDelete(reportedSentence) {
    this.setState({ updating: true });
    this.resolve({ notifyUsers: false, reportedSentence });
  }

  renderCollectionClozeSentenceEditorModal() {
    const { editingReportedSentence } = this.state;

    if(!editingReportedSentence) {
      return null;
    }
    

    return (
      <CollectionClozeSentenceEditor
        collectionClozeSentence={editingReportedSentence}
        collectionClozeSentenceUrl={editingReportedSentence.collectionClozeSentenceUrl}
        clozeSentenceUrl={editingReportedSentence.clozeSentenceUrl}
        onDelete={() => this.onDelete(editingReportedSentence)}
        onHidden={() => this.setState({ editingReportedSentence: false })}
        onUpdate={(updatedSentenceAttributes) => {
          const updatedSentence = withAiRecommendationStaleness(
            editingReportedSentence,
            Object.assign({}, editingReportedSentence, updatedSentenceAttributes)
          );
          this.setState({
            editingReportedSentence: updatedSentence,
            reportedSentences: this.state.reportedSentences.map((reportedSentence) => {
              if(reportedSentence.id === editingReportedSentence.id) {
                return updatedSentence;
              }
              return reportedSentence;
            })
          });
        }}
        textEditingDisabled={editingReportedSentence.lockedField === "text"}
        translationEditingDisabled={editingReportedSentence.lockedField === "translation"}
      />
    );
  }

  renderCollectionClozeSentenceTokensEditor() {
    const { tokensReportedSentence } = this.state;

    if(!tokensReportedSentence) {
      return null;
    }

    return (
      <TokensEditor
        clozeText={tokensReportedSentence.text}
        onHidden={() => this.setState({ tokensReportedSentence: null })}
        tokensUrl={tokensReportedSentence.collectionClozeSentenceTokensUrl}
      />
    );
  }

  renderCollectionClozeSentenceChangesModal() {
    const { changesReportedSentence } = this.state;

    if(!changesReportedSentence) {
      return null;
    }

    return (
      <CollectionClozeSentenceChangesModal
        onHidden={() => this.setState({ changesReportedSentence: null })}
        url={changesReportedSentence.collectionClozeSentenceChangesUrl}
      />
    );
  }

  renderCollectionClozeSentenceTtsModal() {
    const { ttsReportedSentence } = this.state;

    if(!ttsReportedSentence) {
      return null;
    }

    return (
      <CollectionClozeSentenceTts
        clozeSentenceTtsJobUrl={ttsReportedSentence.clozeSentenceTtsJobUrl}
        clozeSentenceUrl={ttsReportedSentence.clozeSentenceUrl}
        collectionClozeSentenceTtsJobUrl={ttsReportedSentence.collectionClozeSentenceTtsJobUrl}
        collectionClozeSentenceUrl={ttsReportedSentence.collectionClozeSentenceUrl}
        onHidden={() => this.setState({ ttsReportedSentence: null })}
      />
    );
  }
  
  renderSeen(e) {
    if(e.resolved || e.claimedByUserUsername) { 
      return null;
    }

    if(e.markedAsSeen) {
      return (
        <div style={{ marginTop: 5 }}>
          <span className="label label-info">👀 Marked as seen by {e.markedAsSeenByUserUsername}</span>
        </div>
      );
    }

    return (
      <div style={{ marginTop: 5 }}>
        <button className="btn btn-default btn-xs" disabled={this.state.updating} onClick={() => this.onMarkAsSeenClick(e)}>Mark as Seen</button>
      </div>
    );
  }

  renderClaim(e) {
    if(e.claimedByCurrentUser) {
      return (
        <div>
          <div>&#x1f449; Me!</div>
          {!e.resolved && (
            <button className="btn btn-warning btn-xs" disabled={this.state.updating} onClick={() => this.onClaimClick(e)}>
              Unclaim
            </button>
          )}
        </div>
      );
    }

    if(!e.claimedByUserUsername) {
      return (
        <button className="btn btn-default" disabled={this.state.updating} onClick={() => this.onClaimClick(e)}>
          Claim
        </button>
      );
    }

    const { admin } = this.props;

    return (
      <div>
        <a className="claimed-by" href={"/players/" + e.claimedByUserUsername} rel="noreferrer" target="_blank">{e.claimedByUserUsername}</a>
        {!!admin && (
          <div style={{ marginTop: 10 }}>
            <small><button className="btn btn-link btn-xs" disabled={this.state.updating} onClick={() => this.onRemoveClaimClick(e)}>Remove claim</button></small>
          </div>
        )}
      </div>
    );
  }

  renderEdit(e) {
    return (
      <>
        <button className="btn btn-default" disabled={!e.claimedByCurrentUser || this.state.updating} onClick={() => this.onEditSentenceClick(e)}>Edit</button>
        <div style={{ marginTop: 5 }}>
          <button className="btn btn-default btn-xs" disabled={!e.claimedByCurrentUser || this.state.updating} onClick={() => this.setState({ explanationModalVisible: true, reportedSentence: e })}>Explanation</button>
        </div>
      </>
    );
  }

  // renderView(e) {
  //   return (
  //     <button className="btn btn-default" disabled={!e.text || this.state.updating} onClick={() => this.onViewSentenceClick(e)}>View</button>
  //   );
  // }

  renderResolve(e) {
    if(e.resolved) {
      return (
        <div>Resolved! &#x1f389;</div>
      );
    }

    return (
      <p><button className="btn btn-default" disabled={!e.claimedByCurrentUser || this.state.updating} onClick={() => this.onResolveClick(e)}>Resolve</button></p>
    );
  }

  renderLanguagePairing() {
    const { baseLanguageName, targetLanguageName } = this.props;

    if(!baseLanguageName || !targetLanguageName) {
      return null;
    }

    return (
      <small>Learning {targetLanguageName} from {baseLanguageName}</small>
    );
  }

  renderLanguagePairingSelector() {
    if(this.props.languagePairingsSelector) {
      const { allLanguagePairingsResolvedCount, allLanguagePairingsTotalCount } = this.state;
      return (
        <div className="pull-right">
          <ul className="list-inline">
            <li>
              <select
                className="form-control"
                id="language-pairing-selector"
                onChange={(e) => this.setState({ collections: null, page: 1, selectedCollectionId: "", selectedLanguagePairingId: parseInt(e.target.value) || "" }, () => this.loadErrors())}
                value={this.state.selectedLanguagePairingId}
              >
                <option value="">All - {allLanguagePairingsResolvedCount}/{allLanguagePairingsTotalCount} ({Math.round(allLanguagePairingsResolvedCount / allLanguagePairingsTotalCount * 100)}%)</option>
                {this.state.languagePairings.map((lp) => {
                  const pct = Math.round(lp.resolved / lp.total * 100);
                  return (
                    <option key={lp.id} value={lp.id}>
                      {lp.targetLanguageEnglishName} from {lp.baseLanguageEnglishName} - {lp.resolved}/{lp.total} ({pct}%)
                    </option>
                  );
                })}
              </select>
            </li>
            <li>{this.renderCollectionSelector()}</li>
          </ul>
        </div>
      );
    }
  }

  renderCollectionSelector() {
    if(!this.state.selectedLanguagePairingId || !this.state.collections) {
      return null;
    }

    return (
      <select
        className="form-control"
        id="collection-selector"
        onChange={(e) => this.setState({ page: 1, selectedCollectionId: parseInt(e.target.value) || "" }, () => this.loadErrors())}
        value={this.state.selectedCollectionId}
      >
        <option value="">All Collections</option>
        {this.state.collections.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
    );
  }

  orderBy(x) {
    this.setState({ orderBy: x, page: 1 }, () => this.loadErrors());
  }

  toggleResolved(includeResolved) {
    this.setState({ includeResolved, page: 1 }, () => this.loadErrors());
  }

  toggleSeen(includeSeen) {
    this.setState({ includeSeen, page: 1 }, () => this.loadErrors());
  }

  filterByAiVerdict(aiVerdict) {
    this.setState({ aiVerdict, page: 1 }, () => this.loadErrors());
  }

  // Composes with the language pairing and collection selectors, so a moderator can work
  // one verdict at a time within the pairing they actually speak. Working a queue of thirty
  // thousand in verdict-homogeneous batches is the difference between deciding a different
  // kind of question every row and building up a feel for one.
  renderAiVerdictFilter() {
    return (
      <span style={{ alignItems: "center", display: "flex", gap: 5 }}>
        <small>AI recommendation:</small>
        <select
          className="form-control input-sm"
          id="ai-verdict-filter"
          onChange={(e) => this.filterByAiVerdict(e.target.value)}
          style={{ width: "auto" }}
          value={this.state.aiVerdict}
        >
          <option value="">All</option>
          <option value="fix_translation">Fix translation</option>
          <option value="fix_text">Fix sentence</option>
          <option value="fix_both">Fix both</option>
          <option value="needs_human">Needs a human</option>
          <option value="no_change">No change needed</option>
          <option value="none">No recommendation yet</option>
        </select>
      </span>
    );
  }

  renderControls() {
    const { includeResolved, includeSeen, orderBy } = this.state;

    return (
      <div>
        <small>Order by:</small>
        {/* Flex for the same reason as renderAiControls: a wrapped .list-inline gets no
            vertical spacing from Bootstrap, so its second line lands on top of the first. */}
        <ul className="list-inline" style={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 5 }}>
          <li>
            <button className={"btn btn-sm btn-default" + (!orderBy ? " active" : "")} onClick={() => this.orderBy(null)}>
              Last report (newest first)
            </button>
          </li>
          <li>
            <button className={"btn btn-sm btn-default" + (orderBy === "oldest" ? " active" : "")} onClick={() => this.orderBy("oldest")}>
              Last report (oldest first)
            </button>
          </li>
          <li>
            <button className={"btn btn-sm btn-default" + (orderBy === "most_reports" ? " active" : "")} onClick={() => this.orderBy("most_reports")}>
              Most reports
            </button>
          </li>
          <li>
            <button className={"btn btn-sm btn-default" + (orderBy === "ai_verdict" ? " active" : "")} onClick={() => this.orderBy("ai_verdict")}>
              AI recommendation
            </button>
          </li>
          <li>
            <label style={{ fontWeight: "normal" }}>
              Include resolved <input checked={includeResolved} name="include_resolved" onChange={(e) => this.toggleResolved(e.target.checked)} type="checkbox" />
            </label>
          </li>
          <li>
            <label style={{ fontWeight: "normal" }}>
              Include seen <input checked={includeSeen} name="include_seen" onChange={(e) => this.toggleSeen(e.target.checked)} type="checkbox" />
            </label>
          </li>
        </ul>
        {this.renderAiControls()}
      </div>
    );
  }

  // Their own row rather than more items in the list-inline above: Bootstrap 3 gives
  // wrapped .list-inline items no vertical spacing, so a second line overlaps the first -
  // and a form-control select is tall enough to make that unmissable. Flex with a gap
  // spaces both directions, however it wraps.
  renderAiControls() {
    return (
      <div style={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 10 }}>
        {this.renderAiVerdictFilter()}
        <label style={{ fontWeight: "normal", marginBottom: 0 }} title="Off by default so you read the sentence and the reports before the AI's verdict.">
          Always show recommendations
          {" "}
          <input
            checked={this.state.expandAiRecommendations}
            name="expand_ai_recommendations"
            onChange={(e) => this.setExpandAiRecommendations(e.target.checked)}
            type="checkbox"
          />
        </label>
        {this.renderGenerateMissingAiRecommendations()}
      </div>
    );
  }

  renderProgressBar() {
    const { languagePairings, selectedLanguagePairingId } = this.state;
    let sum, total;

    if(selectedLanguagePairingId) {
      const languagePairing = languagePairings.find((lp) => lp.id === selectedLanguagePairingId);
      if(languagePairing) {
        sum = languagePairing.resolved;
        total = languagePairing.total;
      }
    }
    else {
      sum = this.state.allLanguagePairingsResolvedCount;
      total = this.state.allLanguagePairingsTotalCount;
    }

    if(!total) {
      return null;
    }

    const percent = Math.round(sum / total * 1000) / 10;

    return (
      <ProgressBar percent={percent}>{sum}/{total} ({percent}%) resolved</ProgressBar>
    );
  }

  renderTts(reportedSentence) {
    if(reportedSentence.hasTts) {
      return (
        <button
          className="btn btn-default"
          disabled={!reportedSentence.claimedByCurrentUser || this.state.updating}
          onClick={() => this.setState({ ttsReportedSentence: reportedSentence })}
        >
          TTS
        </button>
      );
    }
    else {
      return "N/A";
    }
  }

  renderTokensBtn(reportedSentence) {
    if(!reportedSentence.tokensCount) {
      return null;
    }

    return (
      <button
        className="btn btn-default"
        disabled={!reportedSentence.claimedByCurrentUser || this.state.updating}
        onClick={() => this.setState({ tokensReportedSentence: reportedSentence })}
      >
        Tokens
      </button>
    );
  }

  setExpandAiRecommendations(expandAiRecommendations) {
    writeStoredFlag("expandAiRecommendations", expandAiRecommendations);
    this.setState({ expandAiRecommendations });
  }

  updateReportedSentence(id, attributes) {
    this.setState({
      reportedSentences: this.state.reportedSentences.map((r) => (
        r.id === id ? Object.assign({}, r, attributes) : r
      ))
    });
  }

  // expand: false when generating a whole page, so a batch run doesn't fling every verdict
  // open. onComplete fires either way - a page run has to keep going past a failure.
  getAiRecommendation(reportedSentence, { expand = true, onComplete = null, quiet = false } = {}) {
    this.setState({ recommending: Object.assign({}, this.state.recommending, { [reportedSentence.id]: true }) });

    $.ajax({
      method: "post",
      url: reportedSentence.aiRecommendationUrl
    })
      .done(({ reportedCollectionClozeSentence }) => {
        this.updateReportedSentence(reportedCollectionClozeSentence.id, {
          aiRecommendation: reportedCollectionClozeSentence.aiRecommendation,
          aiRecommendationVerdictUrl: reportedCollectionClozeSentence.aiRecommendationVerdictUrl
        });
        this.setState({
          expandedAiRecommendations: expand
            ? Object.assign({}, this.state.expandedAiRecommendations, { [reportedSentence.id]: true })
            : this.state.expandedAiRecommendations,
          recommending: Object.assign({}, this.state.recommending, { [reportedSentence.id]: false })
        });
        onComplete && onComplete();
      })
      .fail((jqXHR) => {
        this.setState({ recommending: Object.assign({}, this.state.recommending, { [reportedSentence.id]: false }) });
        if(!quiet) {
          alert("Couldn't get a recommendation: " + ((jqXHR.responseJSON || {}).errors || "unknown error"));
        }
        onComplete && onComplete();
      });
  }

  // Generates for every row on the page that has nothing yet - the way to try this on a
  // page or two before turning the rake task loose on the backlog.
  //
  // One at a time on purpose: each row is two LLM calls, and firing thirty at once would
  // just collect rate-limit errors. Slow, so it reports progress and can be stopped.
  generateMissingAiRecommendations() {
    const pending = this.state.reportedSentences.filter((r) => (
      r.aiRecommendationUrl && (!r.aiRecommendation || r.aiRecommendation.failed)
    ));

    if(!pending.length) {
      return;
    }

    const generate = (i) => {
      if(i >= pending.length || this.state.stopBulkRecommending) {
        this.setState({ bulkRecommending: false, stopBulkRecommending: false });
        return;
      }

      this.setState({ bulkDone: i });
      this.getAiRecommendation(pending[i], {
        expand: false,
        onComplete: () => generate(i + 1),
        quiet: true
      });
    };

    this.setState({ bulkDone: 0, bulkRecommending: true, bulkTotal: pending.length, stopBulkRecommending: false });
    generate(0);
  }

  renderGenerateMissingAiRecommendations() {
    const { bulkDone, bulkRecommending, bulkTotal, reportedSentences } = this.state;

    if(bulkRecommending) {
      return (
        <span>
          <small className="text-muted">Getting recommendation {bulkDone + 1} of {bulkTotal}&hellip;</small>
          {" "}
          <button className="btn btn-default btn-xs" onClick={() => this.setState({ stopBulkRecommending: true })}>
            Stop
          </button>
        </span>
      );
    }

    const missing = reportedSentences.filter((r) => (
      r.aiRecommendationUrl && (!r.aiRecommendation || r.aiRecommendation.failed)
    )).length;

    if(!missing) {
      return null;
    }

    return (
      <button className="btn btn-default btn-xs" onClick={() => this.generateMissingAiRecommendations()}>
        Get recommendations for this page ({missing})
      </button>
    );
  }

  voteOnAiRecommendation(reportedSentence, verdict, reason) {
    $.ajax({
      data: { reason, verdict },
      method: "post",
      url: reportedSentence.aiRecommendationVerdictUrl
    })
      .done(({ reportedCollectionClozeSentence }) => {
        this.updateReportedSentence(reportedCollectionClozeSentence.id, {
          aiRecommendation: Object.assign(
            {},
            reportedSentence.aiRecommendation,
            reportedCollectionClozeSentence.aiRecommendation
          )
        });
      })
      .fail((jqXHR) => {
        alert("Couldn't record that: " + ((jqXHR.responseJSON || {}).errors || "unknown error"));
      });

    this.setState({
      showVerdictReasonFor: Object.assign({}, this.state.showVerdictReasonFor, {
        [reportedSentence.id]: verdict === "down" && !reason
      })
    });
  }

  renderAiVerdictLabel(recommendation) {
    const labels = {
      fix_both: ["warning", "Fix both"],
      fix_text: ["warning", "Fix sentence"],
      fix_translation: ["warning", "Fix translation"],
      needs_human: ["info", "Needs a human"],
      no_change: ["default", "No change needed"]
    };
    const [style, text] = labels[recommendation.verdict] || ["default", recommendation.verdict];

    return <span className={"label label-" + style}>{text}</span>;
  }

  renderAiColdRead(recommendation) {
    const { assessmentNotes, assessmentTextVerdict, assessmentTranslationVerdict } = recommendation;

    if(!assessmentTextVerdict) {
      return null;
    }

    const translationRead = assessmentTranslationVerdict === "not_assessable"
      ? "not assessable (the sentence itself looks wrong)"
      : assessmentTranslationVerdict;

    return (
      <div className="well well-sm" style={{ marginBottom: 5, padding: 5 }}>
        <small>
          <strong>Cold read</strong> (no reports shown): sentence <em>{assessmentTextVerdict}</em>, translation <em>{translationRead}</em>
          {!!assessmentNotes && <><br />{assessmentNotes}</>}
        </small>
      </div>
    );
  }

  renderAiSuggestions(reportedSentence) {
    const recommendation = reportedSentence.aiRecommendation;
    const { appliedAt, proposedChanges, suggestedText, suggestedTranslation, suggestionWithheld } = recommendation;

    // Applied: the suggestion is the sentence now, and "Changes applied" says so.
    if(appliedAt) {
      return null;
    }

    // Suggestion withheld: the cold read found nothing, so a fix here may be the model
    // agreeing with whoever reported it rather than with the sentence.
    if(suggestionWithheld) {
      return (
        <div>
          <small className="text-muted">
            Suggestion withheld &mdash; the cold read found nothing wrong, so this may just be
            agreeing with the reporter. Your call.
          </small>
        </div>
      );
    }

    if(!suggestedText && !suggestedTranslation) {
      return null;
    }

    if(proposedChanges && Object.keys(proposedChanges).length && !reportedSentence.resolved) {
      const applyDisabledReason = this.applyDisabledReason(reportedSentence);
      const { lockedField } = reportedSentence;
      const lockedSuggestion = { text: suggestedText, translation: suggestedTranslation }[lockedField];
      const lockedChangeLeftOut = !!lockedSuggestion && lockedSuggestion !== reportedSentence[lockedField];

      return (
        <React.Fragment>
          <AiSuggestedChanges
            applyDisabled={this.state.updating || !!applyDisabledReason}
            applyDisabledReason={applyDisabledReason}
            changes={proposedChanges}
            current={{ text: reportedSentence.text, translation: reportedSentence.translation }}
            languageIsos={{ text: reportedSentence.targetLanguageIso, translation: reportedSentence.baseLanguageIso }}
            onApply={() => this.onApplyAiRecommendationClick(reportedSentence)}
          />
          {lockedChangeLeftOut && (
            <div className="ai-locked-change-left-out">
              <small className="text-muted">
                The suggested {FIELD_NAMES[lockedField]} change is left out: it&apos;s shared with other language pairings in this collection.
              </small>
            </div>
          )}
        </React.Fragment>
      );
    }

    return (
      <div style={{ marginTop: 5 }}>
        {!!suggestedText && <div><small><strong>Suggested sentence:</strong> {suggestedText}</small></div>}
        {!!suggestedTranslation && <div><small><strong>Suggested translation:</strong> {suggestedTranslation}</small></div>}
      </div>
    );
  }

  applyDisabledReason(reportedSentence) {
    const { claimedByCurrentUser, claimedByUserUsername } = reportedSentence;

    if(claimedByUserUsername && !claimedByCurrentUser) {
      return `Claimed by ${claimedByUserUsername}.`;
    }

    return null;
  }

  renderAiVerdictButtons(reportedSentence) {
    const { aiRecommendation, aiRecommendationVerdictUrl } = reportedSentence;

    if(!aiRecommendationVerdictUrl) {
      return null;
    }

    // Ahead of the recorded-vote branch on purpose: a thumbs down is saved the moment
    // it's clicked, so checking that first would swallow the follow-up question and lose
    // the only part of the vote worth having.
    if(this.state.showVerdictReasonFor[reportedSentence.id]) {
      return (
        <div style={{ marginTop: 5 }}>
          <small>Why not?</small>
          <div className="btn-group btn-group-xs" style={{ display: "block" }}>
            {[
              ["sentence_fine", "Sentence was fine"],
              ["wrong_fix", "Wrong fix"],
              ["missed_issue", "Missed the issue"]
            ].map(([reason, label]) => (
              <button
                className="btn btn-default"
                key={reason}
                onClick={() => this.voteOnAiRecommendation(reportedSentence, "down", reason)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      );
    }

    if(aiRecommendation.moderatorVerdict) {
      const reasons = {
        missed_issue: "missed the issue",
        sentence_fine: "sentence was fine",
        wrong_fix: "wrong fix"
      };

      return (
        <div style={{ marginTop: 5 }}>
          <small className="text-muted">
            {aiRecommendation.moderatorVerdict === "up" ? "\u{1f44d}" : "\u{1f44e}"}
            {!!aiRecommendation.moderatorVerdictReason && ` — ${reasons[aiRecommendation.moderatorVerdictReason]}`}
          </small>
        </div>
      );
    }

    return (
      <div style={{ marginTop: 5 }}>
        <div className="btn-group btn-group-xs">
          <button
            className="btn btn-default"
            onClick={() => this.voteOnAiRecommendation(reportedSentence, "up")}
            title="Good recommendation"
          >
            &#x1f44d;
          </button>
          <button
            className="btn btn-default"
            onClick={() => this.voteOnAiRecommendation(reportedSentence, "down")}
            title="Bad recommendation"
          >
            &#x1f44e;
          </button>
        </div>
      </div>
    );
  }

  renderAiRecommendation(e) {
    const { aiRecommendation } = e;
    const recommending = !!this.state.recommending[e.id];

    if(recommending) {
      return <small className="text-muted">Getting recommendation&hellip;</small>;
    }

    if(!aiRecommendation) {
      return (
        <button className="btn btn-default btn-xs" onClick={() => this.getAiRecommendation(e)}>Get recommendation</button>
      );
    }

    if(aiRecommendation.failed) {
      return (
        <div>
          <small className="text-danger" title={aiRecommendation.errorMessage}>Generation failed</small>
          <div><button className="btn btn-default btn-xs" onClick={() => this.getAiRecommendation(e)}>Retry</button></div>
        </div>
      );
    }

    const expanded = this.state.expandAiRecommendations || !!this.state.expandedAiRecommendations[e.id];

    if(!expanded) {
      return (
        <button
          className="btn btn-default btn-xs"
          onClick={() => this.setState({
            expandedAiRecommendations: Object.assign({}, this.state.expandedAiRecommendations, { [e.id]: true })
          })}
        >
          Show recommendation
        </button>
      );
    }

    return (
      <div style={{ minWidth: 260, opacity: aiRecommendation.stale ? 0.5 : 1 }}>
        {!!aiRecommendation.stale && (
          <div><small className="text-danger">The sentence changed after this was written &mdash; regenerate before trusting it.</small></div>
        )}
        {this.renderAiColdRead(aiRecommendation)}
        <div>{this.renderAiVerdictLabel(aiRecommendation)}</div>
        <div style={{ marginTop: 5 }}><small>{aiRecommendation.recommendation}</small></div>
        {this.renderAiSuggestions(e)}
        {!!aiRecommendation.appliedAt && (
          <div style={{ marginTop: 5 }}><small className="text-success">Changes applied &#x2714;</small></div>
        )}
        {this.renderAiVerdictButtons(e)}
        <div style={{ marginTop: 5 }}>
          <small>
            <button className="btn btn-link btn-xs" onClick={() => this.getAiRecommendation(e)} style={{ padding: 0 }}>
              Regenerate
            </button>
            {" "}
            <span className="text-muted">({aiRecommendation.reportsCount} {aiRecommendation.reportsCount === 1 ? "report" : "reports"})</span>
          </small>
        </div>
      </div>
    );
  }

  renderContent() {
    const { reportedSentences, loading } = this.state;

    if(loading) {
      return <Loading />;
    }

    return (
      <div>
        {this.renderProgressBar()}
        <div className="row">
          {/* Uneven on purpose: the left side carries the sort buttons, the toggles and the
              AI controls, while the right side is two selects. An even split wrapped the
              left column while the right sat half empty. */}
          <div className="col-xs-12 col-sm-7 col-md-8">{this.renderControls()}</div>
          <div className="col-xs-12 col-sm-5 col-md-4">{this.renderLanguagePairingSelector()}</div>
        </div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Source</th>
              <th>Sentence</th>
              <th>User</th>
              <th>Category</th>
              <th>Feedback</th>
              <th>AI</th>
              {/*<th>View</th>*/}
              <th>Assigned</th>
              <th>Edit</th>
              <th>TTS</th>
              {/*<th>Tatoeba</th>*/}
              <th>Tokens</th>
              <th>Resolve</th>
            </tr>
          </thead>
          <tbody>
            {reportedSentences.map((e) => (
              <tr
                className={"reported-sentence " + (e.resolved ? "success resolved" : (e.claimedByCurrentUser ? "warning" : ""))}
                key={e.id}
                style={e.resolved ? { textDecorationLine: "line-through" } : null}
              >
                <td style={{ minWidth: 150 }}>
                  {!!e.languagePairingSlug && <div>{e.languagePairingSlug}</div>}
                  <div><small><strong>{e.collectionName}</strong></small></div>
                  <small>Last report: {e.lastCreatedAt}</small>
                </td>
                <td style={{ minWidth: 220 }}>
                  {e.text ?
                    <ClozeSentenceEntry
                      baseLanguageIso={e.baseLanguageIso}
                      clozeSentence={e}
                      includeTranslationLinks={true}
                      targetLanguageIso={e.targetLanguageIso}
                    />
                    : "DELETED"
                  }
                </td>
                <td>
                  {
                    e.usernames
                      .map((u) => (
                        <a 
                          className="user"
                          href={"/players/" + u}
                          key={u}
                          rel="noreferrer"
                          target="_blank"
                        >
                          {u}
                        </a>
                      ))
                      .reduce((prev, curr) => [prev, ", ", curr])
                  }
                </td>
                <td>{e.categories.join(" /  ")}</td>
                <td>
                  {e.feedbacks.join(" / ")}
                  {!!e.text && (
                    <>
                      <br />
                      <small><a href={`https://forum.clozemaster.com/search?q=${encodeURI(e.text.replace(/\{\{|\}\}/g, ""))}`} target="_blank">Forum Comments ({e.commentsCount}) <Icon name="new-window" /></a></small>
                    </>
                  )}
                </td>
                <td>{this.renderAiRecommendation(e)}</td>
                {/*<td>{this.renderView(e)}</td>*/}
                <td>
                  {this.renderClaim(e)}
                  {this.renderSeen(e)}
                </td>
                <td>{this.renderEdit(e)}</td>
                <td>{this.renderTts(e)}</td>
                {/*<td>
                  {e.tatoebaId ?
                    <a className="btn btn-link" href={"https://tatoeba.org/eng/sentences/show/" + e.tatoebaId} rel="noreferrer" target="_blank">Tatoeba</a>
                    : "N/A"
                  }
                </td>*/}
                <td>{this.renderTokensBtn(e)}</td>
                <td>
                  {this.renderResolve(e)}
                  <button className="btn btn-xs btn-default" onClick={() => this.setState({ changesReportedSentence: e })}>Changes</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {this.renderPagination()}
        {/*{this.renderViewCollectionClozeSentenceModal()}*/}
        {this.renderCollectionClozeSentenceChangesModal()}
        {this.renderCollectionClozeSentenceEditorModal()}
        {this.renderCollectionClozeSentenceExplanationModal()}
        {this.renderCollectionClozeSentenceTtsModal()}
        {this.renderCollectionClozeSentenceTokensEditor()}
        {this.renderResolveModal()}
        {this.renderApplyModal()}
      </div>
    );
  }

  render() {
    return (
      <div className="container-fluid">
        <h1>Reported Sentences {this.renderLanguagePairing()}</h1>
        <p>How it works: claim a sentence you&apos;d like to fix, make the corrections, then click resolve. &#x1f389;</p>
        {this.renderContent()}
        <a href="/reported-sentences/report-counts-by-week">Report counts by week</a>
      </div>
    );
  }
}
